import { render, staticRenderFns } from "./add-papers-popup.html?vue&type=template&id=21fac1f0&scoped=true&"
import script from "./add-papers-popup.js?vue&type=script&lang=js&"
export * from "./add-papers-popup.js?vue&type=script&lang=js&"
import style0 from "./add-papers-popup.scss?vue&type=style&index=0&id=21fac1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fac1f0",
  null
  
)

export default component.exports